import { getBreakpointValue } from "./helpers";

const headerEl = document.querySelector(".header");
const menuBtnOpenEl = headerEl.querySelector(".header__menu-button--open");
const menuBtnCloseEl = headerEl.querySelector(".header__menu-button--close");
const dialogEl = headerEl.querySelector(".header__dialog");

menuBtnOpenEl?.addEventListener("click", () => {
  headerEl.classList.add("header--open");
  dialogEl?.showModal();
});

menuBtnCloseEl?.addEventListener("click", () => {
  headerEl.classList.remove("header--open");
  dialogEl?.close();
});

const mediaQuery = window.matchMedia(
  `(max-width: ${getBreakpointValue("xl")}px)`
);
const handleMatchMediaChange = (e) => {
  if (!e.matches) {
    dialogEl.close();
  }
};

mediaQuery.addListener(handleMatchMediaChange);

handleMatchMediaChange(mediaQuery);
